export default "__VITE_ASSET__2F2I3XGo__"